import React, { useEffect, useState } from 'react';
import { Table } from 'semantic-ui-react';
import type { CommunicationData } from 'types';
import { CommunicationHelper } from 'utils';

import ZendeskUnassignedRow from './zendeskUnassignedRow';

type FilterType = 'phone';

type ZendeskUnassignedTableProps = {
  communicationsData: CommunicationData;
  communicationsMutate: () => Promise<CommunicationData | undefined>;
  handleErrorMessage: (errorMessage: string) => void;
};

const ZendeskUnassignedTable: React.FC<ZendeskUnassignedTableProps> = ({
  communicationsData,
  communicationsMutate,
  handleErrorMessage,
}) => {
  const [filteredData, setFilteredData] = useState(communicationsData.entry);

  useEffect(() => {
    setFilteredData(communicationsData.entry);
  }, [communicationsData.entry]);

  const _handleFilterChange = ({ type: _type, value }: { type: FilterType; value: string }) => {
    if (!value) {
      setFilteredData(communicationsData.entry);
      return;
    }

    const filtered = communicationsData.entry.filter((entry) => {
      const helper = new CommunicationHelper(entry.resource);
      return helper.getMemberPhoneNumber() === value;
    });

    setFilteredData(filtered);
  };

  return (
    <div className="table-div-message">
      {/* <SearchFilter
        filterOptions={[{ key: 'phone', text: 'Phone Number', value: 'phone', icon: 'phone' }]}
        defaultFilterType="phone"
        autoApply
        onFilterChange={handleFilterChange}
        inputLabelMap={{
          phone: 'Phone Number',
        }}
      /> */}

      <Table basic sortable celled singleLine>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Ticket ID</Table.HeaderCell>
            <Table.HeaderCell>Channel</Table.HeaderCell>
            <Table.HeaderCell>Phone/Email</Table.HeaderCell>
            {/* <Table.HeaderCell>Type</Table.HeaderCell> */}
            <Table.HeaderCell>Assignee</Table.HeaderCell>
            <Table.HeaderCell>Content</Table.HeaderCell>
            <Table.HeaderCell>DateTime</Table.HeaderCell>
            {/* <Table.HeaderCell>Engagement ID</Table.HeaderCell>
            <Table.HeaderCell>Phone Number 1</Table.HeaderCell>
            <Table.HeaderCell>Phone Number 2</Table.HeaderCell>
            <Table.HeaderCell>User</Table.HeaderCell>
            <Table.HeaderCell>Subject</Table.HeaderCell>
            <Table.HeaderCell>Content</Table.HeaderCell>
            <Table.HeaderCell>Date & Time</Table.HeaderCell> */}
            <Table.HeaderCell>Assign Member</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {filteredData.map((communication, index) => (
            <ZendeskUnassignedRow
              key={index}
              communicationsMutate={communicationsMutate}
              communicationResource={communication.resource}
              handleErrorMessage={handleErrorMessage}
            />
          ))}
        </Table.Body>
      </Table>
    </div>
  );
};

export default ZendeskUnassignedTable;
